import React, { Component }        from 'react';
import GoogleMap    from '../GoogleMap.js';
import MetaCartaMap from '../MetaCartaMap';
import GeoUtils from '../../../utils/geoUtils';
import settings from '../../../utils/settings';
import ShowEverythingDialog from '../ShowEverythingDialog';
import urlHandler from '../../../utils/urlHandler';

class DetailedView extends Component{
    constructor(props){
        super(props);

        this.toggleEntities = this.toggleEntities.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.references = this.references.bind(this);
        this.geo = this.geo.bind(this);
        this.detailsCard = this.detailsCard.bind(this);
        this.imageError = this.imageError.bind(this);

        this.state = {
            imageUrls: null, 
            description: null, 
            urls: [],
            geoEnclosingRegion: null,
            geoCoords: null,
            geoPopulation: null,
            geoBoundingBox: null,
            orgInstanceOf: null,
            orgStockExchange: null,
            orgStockTicker: null
        };

        this.mapDisable = window._mapDisable;
        this.mapMetaCartaUrl = window._mapMetaCartaUrl;
        this.externalUrlsDisable = window._externalUrlsDisable;
    }

    toggleEntities() {
        this.props.toggleShowingEntities(this.props.disambiguationResult.id);
    }

    componentDidMount() {
        if (this.props.entityId) {
            const entityData = this.props.getEntityData(this.props.entityId)
            if (entityData){
                this.onSuccess(entityData);
            }
            // console.log(this.props.getEntityData(this.props.entityId));
            // this.onSuccess()
            // urlHandler.sendRequest('entities2', null, this.props.entityId, null, null, (response,txt,status) => {
            //     if (status == 200) {
            //         console.log(response)
            //         this.onSuccess(response);
            //     }
            // });
        } else if (this.props.type && this.props.type === 'places' && this.props.disambiguationResult.attributes && this.props.disambiguationResult.attributes.location) {
            // If we cannot do an entity lookup and this is a GEO entity, try and use information
            // from the disambiguation response as a fallback.
            this.setState({
                geoEnclosingRegion: GeoUtils.getEnclosingRegion(this.props.disambiguationResult.attributes.location),
                geoPopulation: GeoUtils.getPopulation(this.props.disambiguationResult.attributes.location),
                geoCoords: GeoUtils.getCoordinates(this.props.disambiguationResult.attributes.location)
            });            
        }
    };

    onSuccess (response) {
            if (this.props.type != 'places') {

                const imageUrls = response.imageUrls || [];

                

                // Handle language specific label and description fields
                var label = null;
                var description = response.description;
                var urls = response.urls || [];
                if ('languageFields' in response && response.languageFields) {
                    var selectedLang = settings.getValue('languageCode','en');
                    var forceEnglish = settings.getValue('forceEnglish', true);
                    response.languageFields.forEach(function (arrayItem) {
                        if ('langCode' in arrayItem && arrayItem.langCode && arrayItem.langCode === selectedLang && !forceEnglish) {
                            if ('label' in arrayItem && arrayItem.label) {
                                label = arrayItem.label;
                            }
                            if ('description' in arrayItem && arrayItem.description) {
                                description = arrayItem.description;
                            }
                            if ('urls' in arrayItem && arrayItem.urls) {
                                arrayItem.urls.forEach(function(urlItem) {
                                    urls.unshift(urlItem);
                                });
                            }
                        }
                    });
                }

                if (this.props.type === 'orgs') {
                    let inst = null;
                    if ('instanceOf' in response && response.instanceOf) {
                        if (response.instanceOf.length > 0) {
                            inst = response.instanceOf[0];
                        }
                    }
                    let stockExchange = null;
                    let stockTicker = null;
                    if ('stocks' in response && response.stocks) {
                        if (response.stocks.length > 0) {
                            stockExchange = response.stocks[0].operatingMic || response.stocks[0].exchange || null;
                            stockTicker = response.stocks[0].tickerSymbol || null;
                        }
                    }
                    this.setState({
                        imageUrls, 
                        label,
                        description, 
                        urls,
                        orgInstanceOf: inst,
                        orgStockExchange: stockExchange,
                        orgStockTicker: stockTicker,
                        finchId: response.id || null,
                        permIds: response.permIds || null,
                        spgId: response.spgId || null
                    });
                } else {
                    this.setState({
                        imageUrls, 
                        label,
                        description, 
                        urls,
                        finchId: response.id || null,
                        permIds: response.permIds || null,
                        spgId: response.spgId || null
                    });
                }
            } else {
                this.setState({
                    geoEnclosingRegion: GeoUtils.getEnclosingRegion(response),
                    geoPopulation: GeoUtils.getPopulation(response),
                    geoCoords: GeoUtils.getCoordinates(response),
                    geoBoundingBox: GeoUtils.getBoundingBox(response),
                    finchId: response.id || null,
                    permIds: response.permIds || null,
                    spgId: response.spgId || null
                });
            }
    };

    references () {
        return (
            <div className="references-wrapper">
            </div>
        );
    }

    geo () {
        return (
            <div hidden={!this.state.geoCoords}>
                <table>
                    <tbody>
                        <tr>
                            <td className="meta-table-row meta-row-header"><span className="fa fa-angle-double-right"/> Coordinates:&nbsp;</td>
                            <td className="meta-table-row">{this.state.geoCoords}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    imageError({currentTarget}){
        const set = new Set(this.state.imageUrls);
        const newArray = Array.from(set);
        if(newArray.indexOf(currentTarget.src) < newArray.length-1){
            currentTarget.src=newArray[newArray.indexOf(currentTarget.src)+1]
        }
        else{
            // ReactTooltip.hide();
            this.setState({imageUrls: []})
        }
    }

    detailsCard() {
        var cardMapSize = {width: 100 + '%', height: 400 + 'px'};
        return (
            <div className='details-card'>
                <div hidden={!this.props.lat && !this.props.lon || !this.props.lat === 0 && !this.props.lon === 0 || this.mapDisable}
                     className="map">
                    {this.mapMetaCartaUrl ?
                        <MetaCartaMap
                            className="map-container"
                            label={this.props.label} 
                            page={this.props.page || 4}
                            lat={this.props.lat} 
                            lng={this.props.lon} 
                            boundingBox={this.state.geoBoundingBox}/> 
                        :
                        <GoogleMap style={cardMapSize} 
                            label={this.props.label} 
                            page={this.props.page || 4}
                            lat={this.props.lat} 
                            lng={this.props.lon} 
                            boundingBox={this.state.geoBoundingBox}/>
                    }
                </div>
                <pre className='result-json expanded'>

                    {!this.externalUrlsDisable && this.state.imageUrls && this.state.imageUrls[0] &&
					    <img className='thumbnail' src={ this.state.imageUrls[0] } onError={this.imageError}/>
                    }

					<div className='description'>
						<div hidden={!this.state.description} className="description">
						    { this.state.description }<br/>
						</div>
                        {(this.props.entityId || this.props.permIds) &&
                            <br/>
                        }
                        {this.props.entityId &&
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="meta-table-row meta-row-header"><span className="fa fa-angle-double-right"/> Finch Id:&nbsp;</td>
                                            <td className="meta-table-row">
                                                <ShowEverythingDialog 
                                                getEntityData={this.props.getEntityData}
                                                entityName={this.props.label} 
                                                    entityId={this.props.entityId} 
                                                    showLink={true}/>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        }
                        {this.state.permIds &&
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="meta-table-row meta-row-header"><span className="fa fa-angle-double-right"/> Perm Id:&nbsp;</td>
                                            <td className="meta-table-row">
                                            {this.state.permIds.map(function(permid, idx) {
                                                return <div key={idx}>{permid}</div>
                                            })} 
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        }
                        {this.state.spgId &&
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="meta-table-row meta-row-header"><span className="fa fa-angle-double-right"/> S&amp;P Global Id:&nbsp;</td>
                                            <td className="meta-table-row">{this.state.spgId}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        }
                        {('salienceScore' in this.props && this.props.salienceScore != null) &&
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="meta-table-row meta-row-header"><span className="fa fa-angle-double-right"/> Salience Score:&nbsp;</td>
                                            <td className="meta-table-row">{this.props.salienceScore.toFixed(4)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        }
                        {this.props.overallSentiment &&
                            <div>
                                <br/>
                                { this.sentiment() }
                            </div>
                        }
						<div hidden={this.props.type != 'places'}>
                            { this.geo() }
						</div>
					</div>
				</pre>
            </div>
        );
    };

    sentiment () {
        let sentimentClassName;
        if (this.props.overallSentiment) {
            if (this.props.overallSentiment.class === 'positive') {
                sentimentClassName = 'detailed-sentiment-positive';
            } else if (this.props.overallSentiment.class === 'neutral') {
                sentimentClassName = 'detailed-sentiment-neutral';
            } else if (this.props.overallSentiment.class === 'negative') {
                sentimentClassName = 'detailed-sentiment-negative';
            }
        }
        return (
            <div className={ 'detailed-sentiment-wrapper ' + sentimentClassName }>
                {(this.props.overallSentiment.score !== undefined) &&
                    <div>
                        <span className="fa fa-angle-double-right"/>Score : {this.props.overallSentiment.score}
                    </div>
                }
                <div>
                    <span className="fa fa-angle-double-right"/>Class : {this.props.overallSentiment.class}
                </div>
                <div>
                    <span className="fa fa-angle-double-right"/>Confidence : {this.props.overallSentiment.classConfidence}
                </div>
                {('topic' in this.props.overallSentiment) &&
                    <div>
                        <span className="fa fa-angle-double-right"/>Topic : {this.props.overallSentiment.topic}
                    </div>
                }
            </div>
        );
    }

    render () {
        var label = this.state.label || this.props.label;
        return (
            <div>
                {this.props.disambiguationResult.visible ?
                    <div>
                        <p className="details-title">
                            {label} <span hidden={!this.state.geoEnclosingRegion} className="details-region">({this.state.geoEnclosingRegion})</span>
                            <span hidden={!this.state.orgInstanceOf} className="details-region">({this.state.orgInstanceOf})</span>
                        </p>
                        <p hidden={!this.state.geoPopulation} className="details-population">
                            Population: {this.state.geoPopulation}
                        </p>
                        <p hidden={!this.state.orgStockExchange || !this.state.orgStockTicker} className="details-stocks">
                            ({this.state.orgStockTicker}) {this.state.orgStockExchange}
                        </p>
                        <div>
                            { this.detailsCard() }
                        </div>
                        <div>
                            <div>
                                {this.props.disambiguationResult.isParent && this.props.disambiguationResult.hasChildren ?
                                    <div className="mention">
                                        { this.props.disambiguationResult.childrenVisible ?
                                            <h3 onClick={this.toggleEntities} className="result-title">
                                                <span className="result-toggle fa fa-chevron-down"></span>
                                                <span>Hide</span>
                                            </h3>
                                            :
                                            <h3 onClick={this.toggleEntities} className="result-title">
                                                <span className="result-toggle fa fa-chevron-right"></span>
                                                <span>Show more ...</span>
                                            </h3>
                                        }
                                    </div>
                                    : null }
                            </div>
                        </div>

                    </div>
                    : null }
            </div>
        );
    }
};

export default DetailedView;
